import { all, call, put, takeLatest } from "redux-saga/effects";

import { getProfileWorkBeforeApi } from "core/http/service/operationProcess";
import {
  getProfileWorkBeforeSuccess,
  getProfileWorkBeforeFailed,
  getProfileWorkBeforeStart,
} from "../redux/getProfileWorkBefore";

function* getWorkProfileBeforeWork() {
  try {
    const res = yield call(getProfileWorkBeforeApi);

    yield put({
      type: getProfileWorkBeforeSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getProfileWorkBeforeFailed.type,
    });
  }
}
function* watchGetWorkProfileBefore() {
  yield takeLatest(getProfileWorkBeforeStart.type, getWorkProfileBeforeWork);
}

export default function* getGetWorkProfileBeforeSaga() {
  yield all([watchGetWorkProfileBefore()]);
}
